import React from "react";

interface QuickAddButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const QuickAddButton = ({ onClick }: QuickAddButtonProps) => {
  return (
    <button
      className="flex items-center justify-center rounded-full bg-neutrals-white w-[24px] h-[24px] md:w-[44px] md:h-[44px]"
      onClick={onClick}
    >
      <span className="md:hidden" dangerouslySetInnerHTML={{ __html: window.iconPlusSm }}></span>
      <span className="maxMd:hidden" dangerouslySetInnerHTML={{ __html: window.iconPlusMd }}></span>
    </button>
  );
};
